"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.IOevAuctionHouse__factory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [],
        name: "AwardDetailsAreEmpty",
        type: "error",
    },
    {
        inputs: [],
        name: "AwardHasExpired",
        type: "error",
    },
    {
        inputs: [],
        name: "BidAmountIsZero",
        type: "error",
    },
    {
        inputs: [],
        name: "BidDetailsAreEmpty",
        type: "error",
    },
    {
        inputs: [],
        name: "BidFulfillmentCannotBeConfirmed",
        type: "error",
    },
    {
        inputs: [],
        name: "BidFulfillmentCannotBeContradicted",
        type: "error",
    },
    {
        inputs: [],
        name: "BidHasExpired",
        type: "error",
    },
    {
        inputs: [],
        name: "BidIsAlreadyPlaced",
        type: "error",
    },
    {
        inputs: [],
        name: "BidIsNotAwaitingAward",
        type: "error",
    },
    {
        inputs: [],
        name: "BidIsNotAwaitingFulfillmentReport",
        type: "error",
    },
    {
        inputs: [],
        name: "BidLifetimeIsLongerThanMaximum",
        type: "error",
    },
    {
        inputs: [],
        name: "BidLifetimeIsShorterThanMinimum",
        type: "error",
    },
    {
        inputs: [],
        name: "BidderAddressIsZero",
        type: "error",
    },
    {
        inputs: [],
        name: "BidderBalanceIsLowerThanTheLockedAmount",
        type: "error",
    },
    {
        inputs: [],
        name: "BidderCannotWithdrawYet",
        type: "error",
    },
    {
        inputs: [],
        name: "BidderHasAlreadyInitiatedWithdrawal",
        type: "error",
    },
    {
        inputs: [],
        name: "ChainIdIsZero",
        type: "error",
    },
    {
        inputs: [],
        name: "CollateralRateIsNotPositive",
        type: "error",
    },
    {
        inputs: [],
        name: "CollateralRateIsStale",
        type: "error",
    },
    {
        inputs: [],
        name: "DepositAmountIsZero",
        type: "error",
    },
    {
        inputs: [],
        name: "FulfillmentDetailsAreEmpty",
        type: "error",
    },
    {
        inputs: [],
        name: "InsufficientBalance",
        type: "error",
    },
    {
        inputs: [],
        name: "MaxCollateralAmountIsExceeded",
        type: "error",
    },
    {
        inputs: [],
        name: "MaxProtocolFeeAmountIsExceeded",
        type: "error",
    },
    {
        inputs: [],
        name: "MaximumAuctioneerDataLengthIsExceeded",
        type: "error",
    },
    {
        inputs: [],
        name: "MaximumBidderDataLengthIsExceeded",
        type: "error",
    },
    {
        inputs: [],
        name: "NativeCurrencyRateIsNotPositive",
        type: "error",
    },
    {
        inputs: [],
        name: "NativeCurrencyRateIsStale",
        type: "error",
    },
    {
        inputs: [],
        name: "ProxyAddressIsZero",
        type: "error",
    },
    {
        inputs: [],
        name: "RecipientAddressIsZero",
        type: "error",
    },
    {
        inputs: [],
        name: "SenderHasNotInitiatedWithdrawal",
        type: "error",
    },
    {
        inputs: [],
        name: "SenderIsNotAProxySetterOrTheManager",
        type: "error",
    },
    {
        inputs: [],
        name: "SenderIsNotAWithdrawerOrTheManager",
        type: "error",
    },
    {
        inputs: [],
        name: "SenderIsNotAnAuctioneer",
        type: "error",
    },
    {
        inputs: [],
        name: "SenderIsNotTheManager",
        type: "error",
    },
    {
        inputs: [],
        name: "TimestampDoesNotExpediteExpiration",
        type: "error",
    },
    {
        inputs: [],
        name: "WithdrawalAmountIsZero",
        type: "error",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "bidder",
                type: "address",
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "bidTopic",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "bidId",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "awardDetails",
                type: "bytes",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "bidderBalance",
                type: "uint256",
            },
        ],
        name: "AwardedBid",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "bidder",
                type: "address",
            },
        ],
        name: "CanceledWithdrawal",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "bidder",
                type: "address",
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "bidTopic",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "bidId",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "bidderBalance",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "accumulatedProtocolFees",
                type: "uint256",
            },
        ],
        name: "ConfirmedFulfillment",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "bidder",
                type: "address",
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "bidTopic",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "bidId",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "bidderBalance",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "accumulatedSlashedCollateral",
                type: "uint256",
            },
        ],
        name: "ContradictedFulfillment",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "bidder",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "bidderBalance",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "address",
                name: "sender",
                type: "address",
            },
        ],
        name: "Deposited",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "bidder",
                type: "address",
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "bidTopic",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "bidId",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "uint32",
                name: "expirationTimestamp",
                type: "uint32",
            },
        ],
        name: "ExpeditedBidExpiration",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "bidder",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "earliestWithdrawalTimestamp",
                type: "uint256",
            },
        ],
        name: "InitiatedWithdrawal",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "bidder",
                type: "address",
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "bidTopic",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "bidId",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "chainId",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "bidAmount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "bidDetails",
                type: "bytes",
            },
            {
                indexed: false,
                internalType: "uint32",
                name: "expirationTimestamp",
                type: "uint32",
            },
            {
                indexed: false,
                internalType: "uint104",
                name: "collateralAmount",
                type: "uint104",
            },
            {
                indexed: false,
                internalType: "uint104",
                name: "protocolFeeAmount",
                type: "uint104",
            },
        ],
        name: "PlacedBid",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "bidder",
                type: "address",
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "bidTopic",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "bidId",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "fulfillmentDetails",
                type: "bytes",
            },
        ],
        name: "ReportedFulfillment",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "chainId",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "address",
                name: "nativeCurrencyRateProxy",
                type: "address",
            },
        ],
        name: "SetChainNativeCurrencyRateProxy",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "collateralInBasisPoints",
                type: "uint256",
            },
        ],
        name: "SetCollateralInBasisPoints",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "collateralRateProxy",
                type: "address",
            },
        ],
        name: "SetCollateralRateProxy",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "protocolFeeInBasisPoints",
                type: "uint256",
            },
        ],
        name: "SetProtocolFeeInBasisPoints",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "bidder",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "recipient",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "Withdrew",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "recipient",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "WithdrewAccumulatedProtocolFees",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "recipient",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "WithdrewAccumulatedSlashedCollateral",
        type: "event",
    },
    {
        inputs: [],
        name: "AUCTIONEER_ROLE_DESCRIPTION",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "FULFILLMENT_REPORTING_PERIOD",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "MAXIMUM_AUCTIONEER_DATA_LENGTH",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "MAXIMUM_BIDDER_DATA_LENGTH",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "MAXIMUM_BID_LIFETIME",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "MINIMUM_BID_LIFETIME",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "PROXY_SETTER_ROLE_DESCRIPTION",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "WITHDRAWAL_WAITING_PERIOD",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "WITHDRAWER_ROLE_DESCRIPTION",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "accessControlRegistry",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "accumulatedProtocolFees",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "accumulatedSlashedCollateral",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "adminRole",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "adminRoleDescription",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "auctioneerRole",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "bidder",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "bidTopic",
                type: "bytes32",
            },
            {
                internalType: "bytes32",
                name: "bidDetailsHash",
                type: "bytes32",
            },
            {
                internalType: "bytes",
                name: "awardDetails",
                type: "bytes",
            },
            {
                internalType: "uint256",
                name: "awardExpirationTimestamp",
                type: "uint256",
            },
        ],
        name: "awardBid",
        outputs: [
            {
                internalType: "uint256",
                name: "bidderBalance",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "bidder",
                type: "address",
            },
        ],
        name: "bidderToBalance",
        outputs: [
            {
                internalType: "uint256",
                name: "balance",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "bidder",
                type: "address",
            },
        ],
        name: "bidderToEarliestWithdrawalTimestamp",
        outputs: [
            {
                internalType: "uint256",
                name: "earliestWithdrawalTimestamp",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "bidId",
                type: "bytes32",
            },
        ],
        name: "bids",
        outputs: [
            {
                internalType: "enum IOevAuctionHouse.BidStatus",
                name: "status",
                type: "uint8",
            },
            {
                internalType: "uint32",
                name: "expirationTimestamp",
                type: "uint32",
            },
            {
                internalType: "uint104",
                name: "collateralAmount",
                type: "uint104",
            },
            {
                internalType: "uint104",
                name: "protocolFeeAmount",
                type: "uint104",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "cancelWithdrawal",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "chainId",
                type: "uint256",
            },
        ],
        name: "chainIdToNativeCurrencyRateProxy",
        outputs: [
            {
                internalType: "address",
                name: "nativeCurrencyRateProxy",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "collateralInBasisPoints",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "collateralRateProxy",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "bidder",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "bidTopic",
                type: "bytes32",
            },
            {
                internalType: "bytes32",
                name: "bidDetailsHash",
                type: "bytes32",
            },
        ],
        name: "confirmFulfillment",
        outputs: [
            {
                internalType: "uint256",
                name: "bidderBalance",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "accumulatedProtocolFees_",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "bidder",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "bidTopic",
                type: "bytes32",
            },
            {
                internalType: "bytes32",
                name: "bidDetailsHash",
                type: "bytes32",
            },
        ],
        name: "contradictFulfillment",
        outputs: [
            {
                internalType: "uint256",
                name: "bidderBalance",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "accumulatedSlashedCollateral_",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "deposit",
        outputs: [
            {
                internalType: "uint256",
                name: "bidderBalance",
                type: "uint256",
            },
        ],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "bidder",
                type: "address",
            },
        ],
        name: "depositForBidder",
        outputs: [
            {
                internalType: "uint256",
                name: "bidderBalance",
                type: "uint256",
            },
        ],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "bidTopic",
                type: "bytes32",
            },
            {
                internalType: "bytes32",
                name: "bidDetailsHash",
                type: "bytes32",
            },
            {
                internalType: "uint32",
                name: "expirationTimestamp",
                type: "uint32",
            },
        ],
        name: "expediteBidExpiration",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "bidTopic",
                type: "bytes32",
            },
            {
                internalType: "bytes32",
                name: "bidDetailsHash",
                type: "bytes32",
            },
        ],
        name: "expediteBidExpirationMaximally",
        outputs: [
            {
                internalType: "uint32",
                name: "expirationTimestamp",
                type: "uint32",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "chainId",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "bidAmount",
                type: "uint256",
            },
        ],
        name: "getCurrentCollateralAndProtocolFeeAmounts",
        outputs: [
            {
                internalType: "uint104",
                name: "collateralAmount",
                type: "uint104",
            },
            {
                internalType: "uint104",
                name: "protocolFeeAmount",
                type: "uint104",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "initiateWithdrawal",
        outputs: [
            {
                internalType: "uint256",
                name: "earliestWithdrawalTimestamp",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "manager",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes[]",
                name: "data",
                type: "bytes[]",
            },
        ],
        name: "multicall",
        outputs: [
            {
                internalType: "bytes[]",
                name: "returndata",
                type: "bytes[]",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "bidTopic",
                type: "bytes32",
            },
            {
                internalType: "uint256",
                name: "chainId",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "bidAmount",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "bidDetails",
                type: "bytes",
            },
            {
                internalType: "uint256",
                name: "maxCollateralAmount",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "maxProtocolFeeAmount",
                type: "uint256",
            },
        ],
        name: "placeBid",
        outputs: [
            {
                internalType: "uint32",
                name: "expirationTimestamp",
                type: "uint32",
            },
            {
                internalType: "uint104",
                name: "collateralAmount",
                type: "uint104",
            },
            {
                internalType: "uint104",
                name: "protocolFeeAmount",
                type: "uint104",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "bidTopic",
                type: "bytes32",
            },
            {
                internalType: "uint256",
                name: "chainId",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "bidAmount",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "bidDetails",
                type: "bytes",
            },
            {
                internalType: "uint256",
                name: "maxCollateralAmount",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "maxProtocolFeeAmount",
                type: "uint256",
            },
            {
                internalType: "uint32",
                name: "expirationTimestamp",
                type: "uint32",
            },
        ],
        name: "placeBidWithExpiration",
        outputs: [
            {
                internalType: "uint104",
                name: "collateralAmount",
                type: "uint104",
            },
            {
                internalType: "uint104",
                name: "protocolFeeAmount",
                type: "uint104",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "protocolFeeInBasisPoints",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "proxySetterRole",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "bidTopic",
                type: "bytes32",
            },
            {
                internalType: "bytes32",
                name: "bidDetailsHash",
                type: "bytes32",
            },
            {
                internalType: "bytes",
                name: "fulfillmentDetails",
                type: "bytes",
            },
        ],
        name: "reportFulfillment",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "chainId",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "nativeCurrencyRateProxy",
                type: "address",
            },
        ],
        name: "setChainNativeCurrencyRateProxy",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "collateralInBasisPoints_",
                type: "uint256",
            },
        ],
        name: "setCollateralInBasisPoints",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "collateralRateProxy_",
                type: "address",
            },
        ],
        name: "setCollateralRateProxy",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "protocolFeeInBasisPoints_",
                type: "uint256",
            },
        ],
        name: "setProtocolFeeInBasisPoints",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes[]",
                name: "data",
                type: "bytes[]",
            },
        ],
        name: "tryMulticall",
        outputs: [
            {
                internalType: "bool[]",
                name: "successes",
                type: "bool[]",
            },
            {
                internalType: "bytes[]",
                name: "returndata",
                type: "bytes[]",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address payable",
                name: "recipient",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "withdraw",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address payable",
                name: "recipient",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "withdrawAccumulatedProtocolFees",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address payable",
                name: "recipient",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "withdrawAccumulatedSlashedCollateral",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "withdrawerRole",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
];
class IOevAuctionHouse__factory {
    static abi = _abi;
    static createInterface() {
        return new ethers_1.Interface(_abi);
    }
    static connect(address, runner) {
        return new ethers_1.Contract(address, _abi, runner);
    }
}
exports.IOevAuctionHouse__factory = IOevAuctionHouse__factory;
//# sourceMappingURL=IOevAuctionHouse__factory.js.map